/**
 * Maps an org-scoped contact list row (BFF `ContactsListModel` shape) to the
 * `OrganisationContactItem` consumed by the organisation Contacts tab.
 */
export function mapApiOrganisationContactToItem(item) {
    return {
        contactId: item.id,
        roleId: item.roleId ?? "",
        firstName: item.firstName,
        lastName: item.lastName,
        avatarUrl: item.avatarUrl,
        externalId: item.externalId ?? null,
        salutation: item.salutation ?? null,
        birthDate: item.birthDate,
        courtesy: item.courtesy ?? null,
        maidenName: item.maidenName ?? null,
        gender: item.gender ?? null,
        countryOfResidence: item.countryOfResidence ?? null,
        preferredLanguage: item.preferredLanguage ?? null,
        primaryEmail: item.primaryEmail ?? null,
        primaryPhone: item.primaryPhone ?? null,
        status: item.status ?? "",
        createdAt: item.createdAt ?? null,
        updatedAt: item.updatedAt ?? null,
        roleTitle: item.roleTitle ?? null,
        roleFunction: item.roleFunction ?? "",
        startDate: item.roleStartDate,
        endDate: item.roleEndDate,
        roleStatus: item.roleStatus ?? "",
    };
}
